import { Controller } from "@hotwired/stimulus"

// Copies a code snippet to the clipboard from an icon button positioned inside the snippet
// itself, swapping the clipboard icon for a checkmark for a couple of seconds to confirm it
// worked. Distinct from clipboard_controller (the postmortem page's own "Copy as Markdown"
// button): that one swaps a text label, this one only ever has an icon to swap, and the two
// buttons look and behave differently enough that sharing one controller between them would mean
// branching on which target happened to be present rather than two small, single-purpose ones.
export default class extends Controller {
  static targets = ["source", "icon"]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      this.iconTarget.classList.remove("bi-clipboard")
      this.iconTarget.classList.add("bi-clipboard-check")
      clearTimeout(this.resetTimeout)
      this.resetTimeout = setTimeout(() => {
        this.iconTarget.classList.remove("bi-clipboard-check")
        this.iconTarget.classList.add("bi-clipboard")
      }, 2000)
    })
  }
}
